<n-slide-window *ngIf="pageReady" [visible]="windowVisible" width="8.5rem" [loading]="loading" (onHide)="close()">
    <n-header>
        <h1>{{i18n.createTitle}}</h1>
        <n-help-link key="fsCreate"></n-help-link>
        <button nButton id="fs_smartgui_modify_btn" class="modify-btn" type="text" [label]="i18n.modifyBtn"
            (click)="smartGuiModify()">
        </button>
    </n-header>

    <n-block>
        <n-lv>
            <!-- 以下为智能推荐数据 -->
            <n-lv-item [label]="str.smartgui.recDes" [colspan]="2">
            </n-lv-item>
            <!-- 基本信息 -->
            <n-lv-item [colspan]="2" [labelHide]="true">
                <span class="title-md">{{i18n.basicInfoLab}}</span>
            </n-lv-item>
            <!-- 所属租户 -->
            <n-lv-item [label]="i18n.vStoreLab">
                <span>{{handleSmartguiFsData.vstoreName || UNPLACEHOLDER}}</span>
            </n-lv-item>
            <!-- 名称 -->
            <n-lv-item [label]="i18n.nameLab" className="label-title">
                <span>{{handleSmartguiFsData.name || UNPLACEHOLDER}}</span>
            </n-lv-item>
            <!-- 所属储存池 -->
            <n-lv-item [label]="i18n.storagePoolLab">
                <span>{{handleSmartguiFsData.storagepool || UNPLACEHOLDER}}</span>
            </n-lv-item>
            <!-- 安全模式 -->
            <n-lv-item [label]="i18n.securityStyleLab">
                <span>{{utilService.getLabelFromOptions | fn :str.tempSecurityOpts :handleSmartguiFsData.securitymode}}</span>
                <p class="sub mt-5" *ngIf="str.showSecurityBottomTipItem.includes(fsSmartguiData.securitystyle) && !ProductConfig.isOnlySupportUnixSecurityStyle">
                    {{i18n.securityStyleAllTip}}
                </p>
            </n-lv-item>
            <!-- NAS锁定策略 -->
            <n-lv-item [label]="i18n.lockPolicyLab" *ngIf="handleSmartguiFsData.securitymode === SecurityModeE.Native">
                <span>{{utilService.getLabelFromOptions | fn :str.nasLockingPolicyOpts :handleSmartguiFsData.naslockingpolicy}}</span>
            </n-lv-item>
            <!-- VAAI能力 -->
            <n-lv-item *ngIf="ProductConfig.isSupportVAAISwitch"
                       [label]="i18n.vaaiLab"
                       required="true">
                <span>{{handleSmartguiFsData.vaaiswitch === VaaiSwitchE.ON ? i18n.enableSwitchLab : i18n.disableSwitchLab}}</span>
            </n-lv-item>
            <!-- 容量与调优 -->
            <n-lv-item [colspan]="2" [labelHide]="true">
                <span class="title-md">{{i18n.capAndTunningLab}}</span>
            </n-lv-item>
            <!-- 容量 -->
            <n-lv-item [label]="i18n.capacityLab">
                <span>{{handleSmartguiFsData.capacity || UNPLACEHOLDER}}</span>
            </n-lv-item>
            <!-- 容量告警阈值 -->
            <n-lv-item [label]="i18n.capacityThresholdWithUnitLab">
                <span>{{handleSmartguiFsData.capacitythreshold || UNPLACEHOLDER}}</span>
            </n-lv-item>
            <!-- 快照空间比例（%） -->
            <n-lv-item [label]="i18n.snapshotRate" *ngIf="!ProductConfig.isHideFsSnapshotFeature">
                <span>{{handleSmartguiFsData.snapshotreserveper}}</span>
            </n-lv-item>
            <!-- 应用类型 -->
            <n-lv-item [label]="i18n.workloadTypeLab">
                <span>{{handleSmartguiFsData.workloadtype || UNPLACEHOLDER}}</span>
                <ng-container *ngIf="selectedWorkloadType">
                    <p class="sub mt-5">{{i18n.typeLab + workloadCreateTypeMap[selectedWorkloadType.CREATETYPE]}}</p>
                    <p class="sub mt-5">{{str.getRequestSizeStrByNum | fn :selectedWorkloadType.BLOCKSIZE}}</p>
                    <ng-container *ngIf="!supportGuaranteedCapacity || supportDedupeAndCompression">
                        <p class="sub mt-5">
                            {{i18n.smartCompressionLab + (selectedWorkloadType.ENABLECOMPRESS === 'true' ? i18n.enabledLab : i18n.disabledLab)}}
                        </p>
                        <p class="sub mt-5">
                            {{i18n.smartDedupLab + (selectedWorkloadType.ENABLEDEDUP === 'true' ? i18n.enabledLab : i18n.disabledLab)}}
                        </p>
                    </ng-container>
                    <p class="sub mt-5">{{i18n.distributionAlgoLabel + (utilService.getLabelFromOptions | fn :str.DistAlgOpts :selectedWorkloadType.distAlg)}}</p>
                </ng-container>
            </n-lv-item>
            <!-- 双活 -->
            <ng-container *ngIf="vstorePairId || getHyperMetroPairError">
                <n-lv-item [colspan]="2" [labelHide]="true">
                    <span class="title-md">{{ i18n.hyperMetroPairLab }}</span>
                </n-lv-item>
                <n-lv-item [label]="i18n.remoteVstoreLab">
                    <span>{{ remoteVstoreName || UNPLACEHOLDER }}</span>
                </n-lv-item>
                <n-lv-item [label]="i18n.hyperMetroDomainLab">
                    <span >{{ fsHyperMetroDomain?.NAME || UNPLACEHOLDER }}</span>
                </n-lv-item>
                <n-lv-item [label]="i18n.remoteStoragePollLab">
                    <n-select [(ngModel)]="remoteParentId"
                        style="width: 3rem;"
                        id="remote_storage_poll"
                        [options]="remoteStoragePoolOpts"
                        [filter]="true"></n-select>
                    <n-tip *ngIf="!remoteParentId"
                        type="failed">
                        {{ i18n.remoteStoragePoolError }}
                    </n-tip>
                </n-lv-item>
            </ng-container>

            <!-- 共享标题, 只有主入口才支持共享 -->
            <n-lv-item *ngIf="entry === FileSystemEntryE.Main && hasSharePermission"
                [colspan]="2"
                [labelHide]="true">
                <span class="title-md">{{i18n.shareLab}}</span>
                <!-- NFS -->
                <n-card-panel class="copy-from-share">
                    <div slot="title" class="copy-from-switch">
                        <h2>{{i18n.nfs}}</h2>
                        <n-switch id="copy-from-gui-nfs" [(ngModel)]="shareSwitch.nfs">
                        </n-switch>
                    </div>
                    <!-- 共享label -->
                    <n-lv *ngIf="shareSwitch.nfs">
                        <n-lv-item [label]="i18n.share" className="label-title">
                            <!-- 共享路径 -->
                            <span nTextTips class="share-path">{{sharePath.nfs}}</span>
                            <!-- 逗号 -->
                            <span>{{i18n.comma}}</span>
                            <!-- 权限数-->
                            <span>{{permissionStr.nfs}}</span>
                        </n-lv-item>
                    </n-lv>
                </n-card-panel>
                <!-- CIFS -->
                <n-card-panel class="copy-from-share" *ngIf="!ProductConfig.isHideCifs">
                    <n-loading [visible]="true" *ngIf="loadingCifs"></n-loading>
                    <div slot="title" class="copy-from-switch">
                        <h2>{{i18n.cifs}}</h2>
                        <n-switch id="copy-from-gui-cifs" [(ngModel)]="shareSwitch.cifs">
                        </n-switch>
                    </div>
                    <!-- 共享label -->
                    <n-lv *ngIf="shareSwitch.cifs">
                        <n-lv-item [label]="i18n.share" className="label-title">
                            <!-- 共享名 -->
                            <span nTextTips class="share-path">{{cifs.NAME || UNPLACEHOLDER}}</span>
                            <!-- 逗号 -->
                            <span>{{i18n.comma}}</span>
                            <!-- 权限数-->
                            <span>{{permissionStr.cifs}}</span>
                        </n-lv-item>
                    </n-lv>
                </n-card-panel>
            </n-lv-item>
            <!-- 保护 -->
            <n-lv-item [colspan]="2" [labelHide]="true"
                *ngIf="hasCdpPermission">
                <span class="title-md">{{i18n.fsProtectionLab}}</span>
                <n-card-panel class="copy-from-share">
                    <div slot="title" class="copy-from-switch">
                        <!-- 加入CDP定时计划label -->
                        <h2>{{i18n.addToCdpTitle}}</h2>
                        <!-- 加入CDP定时计划开关 -->
                        <n-switch id="copy-from-gui-cdp" [(ngModel)]="addToCdpScheduleSwitch">
                        </n-switch>
                    </div>
                    <n-lv *ngIf="addToCdpScheduleSwitch">
                        <n-lv-item [label]="i18n.hyperCdpScheduleForFileSystemLab" className="label-title">
                            <!-- 内置CDP定时计划名称 -->
                            <div>{{defaultCdpSchedule?.NAME || DEFAULT_CDP_SCHEDULE_NAME}}</div>
                            <!-- 状态 -->
                            <div>
                                <!-- 无CDP内置定时计划tip -->
                                <div *ngIf="!defaultCdpSchedule" style="display: flex;">
                                    <span class="tipsText sub mt-5" nTextTips>{{str.i18n.noDefaultCdpScheduleTip}}</span>
                                </div>
                                <div *ngIf="defaultCdpSchedule">
                                    <span class="sub mt-5" style="margin-right: 23px;">{{str.i18n.statusLab}}</span>
                                    <span class="tipsText sub mt-5" nTextTips>{{statusRender | fn :defaultCdpSchedule?.RUNNINGSTATUS}}</span>
                                </div>
                            </div>
                            <!-- 策略 -->
                            <ng-container *ngFor="let sty of defaultCdpSchedule?.strategy; index as i">
                                <div>
                                    <span [class.visibility-hidden]="i !== 0" class="sub mt-5">{{str.i18n.strategyLab}}</span>
                                    <span nTextTips class="sub mt-5">{{sty}}</span>
                                </div>
                            </ng-container>
                        </n-lv-item>
                    </n-lv>
                </n-card-panel>
            </n-lv-item>
            <!-- 防病毒 -->
            <n-lv-item [colspan]="2" [labelHide]="true"
                *ngIf="showAntivirus">
                <span class="title-md">{{i18n.antivirusTitle}}</span>
                <!-- 防病毒后台策略卡片 -->
                <div class="mb-20 mt-20">
                    <app-create-fs-scan-mission-policy-card #ondemandCard
                        [vstoreId]="vstore.value || SYSTEM_VSTORE_ID"
                        [vm]="vm"
                        [type]="ScanPolicyTypeE.ONDEMAND">
                    </app-create-fs-scan-mission-policy-card>
                </div>
                <!-- 防病毒实时策略卡片 -->
                <div>
                    <app-create-fs-scan-mission-policy-card #onaccessCard
                        [vstoreId]="vstore.value || SYSTEM_VSTORE_ID"
                        [vm]="vm"
                        [type]="ScanPolicyTypeE.ONACCESS">
                    </app-create-fs-scan-mission-policy-card>
                </div>
            </n-lv-item>
            <!-- 属性 -->
            <n-lv-item [colspan]="2" [labelHide]="true">
                <span class="title-md">{{i18n.fsPropertyLab}}</span>
            </n-lv-item>
            <!-- 快照目录是否可见 -->
            <n-lv-item [label]="i18n.isShowSnapshotDirLab" *ngIf="!ProductConfig.isHideFsSnapshotFeature">
                <span>{{utilService.getLabelFromOptions | fn :str.showSnapshotDirOpts :handleSmartguiFsData.isshowsnapdir}}</span>
            </n-lv-item>
            <!-- 自动更新Atime -->
            <n-lv-item [label]="i18n.atimeLab">
                <span>{{handleSmartguiFsData.atime === 'true' ? i18n.enableSwitchLab : i18n.disableSwitchLab}}</span>
            </n-lv-item>
            <!-- Atime更新模式 -->
            <n-lv-item *ngIf="fsSmartguiData.atime==='true'" [label]="i18n.atimeUpdateModeLab">
                <span>{{utilService.getLabelFromOptions | fn :str.atimeUpdateModeOpts :handleSmartguiFsData.atimeupdatemode}}</span>
            </n-lv-item>
        </n-lv>
    </n-block>

    <n-footer>
        <button id="create-filesystem-smartgui-btn" nButton theme="primary" [label]="i18n.okBtn" (click)="onOk()">
        </button>
        <button id="filesystem-smartgui-cancel-btn" nButton [label]="i18n.cancelBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
